import { VOGalleryList, VOListItem, VOGalleryMedia } from "../model/DataStructure.js";
import { Indicator } from "./Indicator.js";

export interface MediaLookup {
    galleryList: VOGalleryList;
    galleryIndex: number;
    mediaIndex: number;
}

type GalleryListItemType = "text" | "media";
interface IGalleryListItem {
    kind: GalleryListItemType;
    element: HTMLDivElement;
    gallery: VOListItem;
    media: VOGalleryMedia;
}

export class GalleryList {

    public onRequestGallery = e5.Signal.create<[VOGalleryList, number, number]>();

    public onChangeTop = e5.Signal.create<[IGalleryListItem]>();

    public element: HTMLDivElement;

    public filterClick: (galleryIndex: number, mediaIndex: number) => MediaLookup = null;

    private _galleryList: VOGalleryList = null;
    private _itemsAll: IGalleryListItem[] = [];
    private _items: GalleryListItem[] = [];
    private _itemsLookup: GalleryListItem[] = [];
    private _currentTop: IGalleryListItem = null;
    private _lastManualScroll = Date.now();

    constructor() {
        this.element = document.createElement("div");
        this.element.className = "gallery-list scrollbar vert";
        $(this.element).on("click", "[data-galleryindex][data-mediaindex]", (e) => {
            var galleryIndex = parseInt(e.currentTarget.getAttribute("data-galleryindex"));
            var mediaIndex = parseInt(e.currentTarget.getAttribute("data-mediaindex"));

            if (typeof this.filterClick === "function") {
                var o = this.filterClick(galleryIndex, mediaIndex);
                if (o)
                    this.onRequestGallery.dispatch(o.galleryList, o.galleryIndex, o.mediaIndex);
            }
            else {
                this.onRequestGallery.dispatch(this._galleryList, galleryIndex, mediaIndex);
            }
        });

        this.element.addEventListener("scroll", (e) => {
            if (Date.now() - this._lastManualScroll < 100) {
                return;
            }
            this.updateTop();
        },
            e5.Caps.passiveEventLister ? { passive: true } : false);
    }

    private updateTop(force: boolean = false): void {
        var st = this.element.scrollTop;
        st += 250;

        for (var item of this._itemsAll) {
            var top = item.element.offsetTop;
            var bottom = top + item.element.offsetHeight;
            if (st >= top && st < bottom) {
                if (this._currentTop != item || force) {
                    this.onChangeTop.dispatch(item);
                }
                this._currentTop = item;
                return;
            }
        }
    }

    public show(galleryIndex: number, mediaIndex: number = -1): void {
        var item = this.element.querySelector(`.gallery-item[data-galleryindex="${galleryIndex}"]`) as HTMLDivElement;
        if (item) {
            this._lastManualScroll = Date.now();
            this.element.scrollTop = item.offsetTop;
            if (mediaIndex >= 0 && this._itemsLookup[galleryIndex]) {
                this._itemsLookup[galleryIndex].setMedia(mediaIndex);
            }
        }
    }

    public reset(): void {
        this.element.scrollTop = 0;
        for (var item of this._items) {
            item.reset();
        }
    }

    public create(galleryList: VOGalleryList, showItemsWithoutMedia: boolean = true, expandMedias: boolean = false): void {
        this._galleryList = galleryList;

        this.element.innerHTML = "";
        this.element.scrollTop = 0;
        if (!galleryList || galleryList.all.length === 0)
            return;

        for (var gallery of galleryList.all) {
            if (gallery.list_item_kind === "text") {
                if (showItemsWithoutMedia) {
                    var text = new GalleryListItemText(gallery);
                    this._itemsAll.push(text);
                    this.element.appendChild(text.element);
                }
            }
            else {
                if (showItemsWithoutMedia || gallery.list_item_medias.length > 0) {
                    var item = new GalleryListItem(gallery);
                    this._items.push(item);
                    this._itemsAll.push(item);
                    this._itemsLookup[gallery.index] = item;
                    this.element.appendChild(item.element);
                    item.onChange.add(() => this.updateTop(true));
                }
            }
        }
    }
}

class GalleryListItem implements IGalleryListItem {
    public kind: GalleryListItemType = "media";
    public element: HTMLDivElement;
    public onChange = e5.Signal.create<[GalleryListItem]>();

    private _index: number = 0;

    constructor(public gallery: VOListItem) {
        this.element = document.createElement("div");
        this.element.className = "gallery-item";
        this.element.setAttribute("data-galleryindex", gallery.index + "");

        $(this.element).on("click", ".gallery-item-prev", (e) => {
            e.stopImmediatePropagation();
            this.prev();
        });
        $(this.element).on("click", ".gallery-item-next", (e) => {
            e.stopImmediatePropagation();
            this.next();
        });

        var medias: VOGalleryMedia[] = gallery.list_item_medias;

        for (var media of medias) {

            var title = media.title;
            var subtitle = media.subtitle;
            var description = media.description;
            var author = media.author;

            var url = null;
            if (media.type === "none") {

            } else if (media.type === "image") {
                //TODO: video fallback image...
                // url = media.url;
                url = media.sizes.medium;
            }
            else if (media.type === "video") {
                //TODO: video fallback image...
                url = media.sizes.medium;
            }

            // if (!showItemsWithoutMedia && !url)
            //     continue;

            if (!gallery.list_item_use_text_first_media) {
                title = gallery.list_item_title;
                subtitle = gallery.list_item_subtitle;
                description = gallery.list_item_description;
            }

            var count = gallery.list_item_medias.length;

            var hasText = title || subtitle || description;

            this.element.setAttribute("data-mediaindex", media.index + "");

            this.element.innerHTML = `
                    <div class="gallery-item-image-container">
                        <img class="gallery-item-image" src="${url}" draggable="false"></img>
                        <div class="gallery-item-image-icon icon-${count > 1 ? 513 : 249}"></div>
                        <div class="gallery-item-image-author ${author ? "" : "hidden"}">${author}</div>
                        ${count > 1 ?
                    Indicator.create(0, count) : ""}
                         ${count > 1 ?
                    `<div class="gallery-item-prev icon icon-125"></div><div class="gallery-item-next icon icon-124"></div>` : ""}
                    </div>
                    <div class="gallery-item-text ${hasText ? "" : "hidden"}">
                        <div class="gallery-item-title ${title ? "" : "hidden"}">${title}</div>
                        <div class="gallery-item-subtitle ${subtitle ? "" : "hidden"}">${subtitle}</div>
                        <div class="gallery-item-description ${description ? "" : "hidden"}">${description}</div>
                    </div>`

            break;
        }
    }

    private next(): void {
        var index = parseInt(this.element.getAttribute("data-mediaindex"));
        index = e5.Calc.wrap(index + 1, this.gallery.list_item_medias.length);
        this.setMedia(index);
    }

    private prev(): void {
        var index = parseInt(this.element.getAttribute("data-mediaindex"));
        index = e5.Calc.wrap(index - 1, this.gallery.list_item_medias.length);
        this.setMedia(index);
    }

    public setMedia(index: number): void {
        index = e5.Calc.clamp(index, 0, this.gallery.list_item_medias.length - 1);

        if (this._index == index) {
            return;
        }
        this._index = index;

        var media = this.gallery.list_item_medias[index];
        if (!media) {
            this.element.querySelector(".gallery-item-image-container").classList.add("hidden");
            return;
        }

        var url = null;
        if (media.type === "none") {

        } else if (media.type === "image") {
            //TODO: video fallback image...
            // url = media.url;
            url = media.sizes.medium;
        }
        else if (media.type === "video") {
            //TODO: video fallback image...
            url = media.sizes.medium;
        }

        var hasMedia = Boolean(url);

        this.element.querySelector(".gallery-item-image-container").classList.toggle("hidden", !hasMedia);

        this.element.setAttribute("data-mediaindex", media.index + "");

        this.element.querySelector<HTMLImageElement>(".gallery-item-image").src = url;
        this.element.querySelector(".gallery-item-image-author").classList.toggle("hidden", !media.author);
        this.element.querySelector(".gallery-item-image-author").innerHTML = media.author || "";

        this.element.querySelector(".indicator").innerHTML = Indicator.createInner(index, this.gallery.list_item_medias.length);

        if (this.gallery.list_item_use_text_first_media) {
            var title = media.title;
            var subtitle = media.subtitle;
            var description = media.description;

            var hasText = title || subtitle || description;

            this.element.querySelector(".gallery-item-text").classList.toggle("hidden", !hasText);

            this.element.querySelector(".gallery-item-title").classList.toggle("hidden", !title);
            this.element.querySelector(".gallery-item-subtitle").classList.toggle("hidden", !subtitle);
            this.element.querySelector(".gallery-item-description").classList.toggle("hidden", !description);

            this.element.querySelector(".gallery-item-title").innerHTML = title || "";
            this.element.querySelector(".gallery-item-subtitle").innerHTML = subtitle || "";
            this.element.querySelector(".gallery-item-description").innerHTML = description || "";
        }

        this.onChange.dispatch(this);
    }

    public get media(): VOGalleryMedia {
        return this.gallery.list_item_medias[this._index];
    }

    public reset():void{
        this.setMedia(0);
    }
}

class GalleryListItemText implements IGalleryListItem {
    public kind: GalleryListItemType = "text";
    public element: HTMLDivElement;

    constructor(public gallery: VOListItem) {
        this.element = document.createElement("div");
        this.element.className = "gallery-item";

        var title = gallery.list_item_title;
        var subtitle = gallery.list_item_subtitle;
        var description = gallery.list_item_description;

        var hasText = title || subtitle || description;

        this.element.innerHTML = `${hasText ? `
        <div class="gallery-item-text">
            ${title ? `
            <div class="gallery-item-title">${title}</div>` : ""}
            ${subtitle ? `
            <div class="gallery-item-subtitle">${subtitle}</div>` : ""}
            ${description ? `
            <div class="gallery-item-description">${description}</div>` : ""}
        </div>` : ""}`;
    }

    public get media(): VOGalleryMedia {
        return null;
    }
}